// eslint-disable-next-line import/no-cycle
import asiakasSettingsClass from "./asiakasSettingsClass";
import { asiakas_cacheName, cache_clear } from "src/components/js/CacheFunctions";

export async function asiakasSettings_saveToDB(asiakas, token) {
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(asiakas.settings),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/asiakas/settings/save",
      requestOptions
    );
    return response;
  } catch (error) {
    return error;
  }
}
export async function asiakasSetting_saveToDB(setting, token) {
  // sample setting
  // {
  //   "asiakasSettingId": 0,
  //   "asiakasId": 0,
  //   "laskuttajaAsiakasId": 0,
  //   "asiakasSettingTypeId": 0,
  //   "asiakasSettingBool": false,
  //   "asiakasSettingInt": 0,
  //   "asiakasSettingString": ""
  //   "asiakasSettingJSON": ""
  // }
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(setting),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/asiakas/setting/save",
      requestOptions
    );
    return response;
  } catch (error) {
    return error;
  }
}
export function asiakasSettings_get(asiakas, laskuttajaAsiakasId, asiakasSettingTypeId) {
  let _setting;
  if (asiakas.settings === undefined) asiakas.settings = [];
  _setting = asiakas.settings.find(
    (setting) =>
      setting.laskuttajaAsiakasId === laskuttajaAsiakasId &&
      setting.asiakasSettingTypeId === asiakasSettingTypeId
  );
  if (!_setting)
    _setting = new asiakasSettingsClass(asiakas.asiakasId, asiakas.asiakasId, asiakasSettingTypeId);
  if (asiakasSettingTypeId === 10) {
    // ALV
    if (!_setting.asiakasSettingInt)
      _setting.asiakasSettingInt = import.meta.env.VITE_DEFAULT_ALV_PROM;
  }
  return _setting;
}
export function asiakasSetting_set(
  asiakas,
  laskuttajaAsiakasId,
  asiakasSettingTypeId,
  boolValue = false,
  intValue = null,
  stringValue = null,
  jsonValue = null
) {
  console.log("asiakasSetting_set");
  cache_clear(asiakas_cacheName);
  let _setting;
  if (asiakas.settings === undefined) asiakas.settings = [];
  _setting = asiakas.settings.find(
    (setting) =>
      setting.laskuttajaAsiakasId === laskuttajaAsiakasId &&
      setting.asiakasSettingTypeId === asiakasSettingTypeId
  );
  if (!_setting) {
    _setting = new asiakasSettingsClass(asiakas.asiakasId, asiakas.asiakasId, asiakasSettingTypeId);
    asiakas.settings.push(_setting);
  }
  _setting.asiakasSettingBool = boolValue;
  _setting.asiakasSettingInt = intValue;
  _setting.asiakasSettingString = stringValue;
  _setting.asiakasSettingJSON = jsonValue;
  return _setting;
}
